// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Dropdown from '../../../../../common-utils/components/renders/dropdown/Dropdown';
import ModalDomiciliation from '../../../contracts/components/modals/ModalDomiciliation';
// Common
import ICONS from '../../../../../common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
import MerchantContractDomiciliation from '@/common-utils/enums/MerchantContractDomiciliation';
import searchContractFields from '../../fields/searchContractFields';
import ModalUpdateLabel2 from '../../../contracts/components/modals/ModalUpdateLabel2';
// Lang
import { nsSearchContract } from '@/app/i18n/namespaces';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
/**
 * @param root0
 * @param root0.searchContract
 * @param root0.setLaunchRefetch
 * @returns {JSX} DropdownSearchContractActionsRow
 */
function DropdownSearchContractActionsRow({ searchContract, setLaunchRefetch }) {

    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    // State
    const [showModalShowModalDomiciliation, setShowModalShowModalDomiciliation] = useState(false);
    const [showModalUpdateSearchContract, setShowModalUpdateSearchContract] = useState(false);

    // Constants
    const {
        [searchContractFields.UUID.key]: uuid = null,
        [searchContractFields.NUMBER.key]: contractNumber = null,
        [searchContractFields.APPLICATION.key]: application = null,
        [searchContractFields.LABEL.key]: label = null
    } = searchContract ?? {};

    // Functions
    const handleShowModalUpdateSearchContract = () => {
        setShowModalUpdateSearchContract(true);
    };
    const handleShowModalShowModalDomiciliation = () => {
        setShowModalShowModalDomiciliation(true);
    };

    return (
        <>
            <Dropdown
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.EDIT,
                        namespace: nsSearchContract,
                        entity: 'actions.row.update',
                        onClick: handleShowModalUpdateSearchContract,
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.CONTRACTS_ACCESS_UPDATE.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    },
                    {
                        icon: ICONS.CREDIT_CARD,
                        namespace: nsSearchContract,
                        entity: 'actions.row.dom_card',
                        onClick: handleShowModalShowModalDomiciliation,
                        visible: MerchantContractDomiciliation[application] !== undefined,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.CONTRACTS_ACCESS_READ.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]}
            />
            <ModalDomiciliation
                isOpen={showModalShowModalDomiciliation}
                setIsOpen={setShowModalShowModalDomiciliation}
                isCustomDomiciliation={false}
                contractNumber={contractNumber}
                applicationCode={application}
            />
            <ModalUpdateLabel2
                isOpen={showModalUpdateSearchContract}
                setIsOpen={setShowModalUpdateSearchContract}
                contractId={uuid}
                label={label}
                application={application}
                setLaunchRefetch={setLaunchRefetch}
            />
        </>
    );
}

DropdownSearchContractActionsRow.propTypes = {
    searchContract: PropTypes.object,
    setLaunchRefetch: PropTypes.func
};
export default DropdownSearchContractActionsRow;